// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"706":"release-notes","824":"release-notes-admin"}[chunkId] || chunkId) + "." + {"706":"003a5340","791":"fb4ef45f","824":"d1a8b8ce"}[chunkId] + ".css";
};